/**
 * r2h-pricing-config.js
 * ============================================================
 * R2H — Tabla Maestra de Precios
 * Fuente única de verdad para todos los cálculos de descuento.
 *
 * CÓMO CAMBIAR PRECIOS:
 *   Edita los multiplicadores en la sección PRICE TABLE.
 *   El multiplicador se aplica sobre el MSRP (precio en Shopify).
 *   Ejemplo: 0.750 = el cliente paga 75% del MSRP (25% off exacto).
 *
 * CÓMO SE CONECTA CON EL SISTEMA:
 *   window.B2B_Config  → dice QUIÉN es el cliente (tier)
 *   window.R2H_Pricing → dice QUÉ multiplicador aplica (tier × tipo)
 *   JSV8-P-engine.js   → consulta ambos para mostrar el precio correcto
 * ============================================================
 */

window.R2H_Pricing = {

  // ============================================================
  // PRICE TABLE
  // tier × product_type → multiplicador sobre MSRP
  // ============================================================
  table: {

    retail: {
      'mass market': 0.880,   // 12% off MSRP — solo en checkout
      'premium': 0.710,   // 29% off MSRP — solo en checkout
      'pictufy': 0.790,   // 21% off MSRP — solo en checkout
      'originals': 1.0,     // sin descuento (confirmado con Juliana)
      'fresenius': 1.0,     // sin descuento
    },

    trade: {
      'mass market': 0.750,   // 25% off MSRP
      'premium': 0.610,   // 39% off MSRP
      'pictufy': 0.670,   // 33% off MSRP
      'originals': 1.0,     // sin descuento (confirmado con Juliana)
      'fresenius': 1.0,     // sin descuento
    },

    wholesale: {
      'mass market': 0.490,   // ~51% off MSRP
      'premium': 0.290,   // ~71% off MSRP
      'pictufy': 0.360,   // ~64% off MSRP
      'originals': null,    // ❌ NO disponible para wholesale
      'fresenius': 1.0,     // sin descuento
    },

  },

  // ============================================================
  // TAG NAMES — nombres exactos de los tags en Shopify
  // (el sistema los compara en minúsculas automáticamente)
  // ============================================================
  tags: {
    product: {
      mass: 'mass market',
      premium: 'premium',
      pictufy: 'pictufy',
      originals: 'originals',
      fresenius: 'fresenius',
    },
    customer: {
      trade: 'trade',
      wholesale: 'wholesale',
    },
  },

  // ============================================================
  // REGLAS DE NEGOCIO
  // ============================================================
  rules: {
    // Wholesale NO puede comprar estos productos
    wholesale_blocked: ['originals', 'fresenius'],

    // Nunca reciben descuento, sin importar el tier
    never_discount: ['fresenius'],

    // Retail: el descuento se aplica SOLO en checkout, no en navegación
    retail_checkout_only: true,
  },

};

// Verificación rápida en consola (se puede borrar en producción)
console.log('[R2H Pricing] Tabla cargada:', window.R2H_Pricing);
